/**
 * Optional Fully Kiosk Browser diagnostics (L3).
 * @see https://www.fully-kiosk.com/docs/#javascript-api
 * @returns {{ title: string, rows: Array<{ label: string, value: string }> } | null}
 */
export function fullyDiagnosticsSection() {
  const f = globalThis.fully;
  if (!f || typeof f.getDeviceId !== 'function') return null;

  const rows = [{ label: 'Device ID', value: String(f.getDeviceId()) }];

  if (typeof f.getBatteryLevel === 'function') {
    rows.push({ label: 'Battery', value: String(f.getBatteryLevel()) });
  }
  if (typeof f.getWifiSsid === 'function') {
    rows.push({ label: 'WiFi SSID', value: String(f.getWifiSsid()) });
  }

  return { title: 'Fully Kiosk', rows };
}
